import { Outlet, useParams } from 'react-router-dom';
import AllGroupsGrid from './all-groups-grid';

import Box from '@mui/material/Box';
import SharedTabHeader from '../../shared/shared-tab-header';

export default function AllGroupsPage() {
  const { groupEmail } = useParams() as { groupEmail: string | undefined };

  if (groupEmail) {
    return <Outlet />;
  }

  return (
    <Box
      sx={{
        p: 2,
        pt: 1,
      }}
    >
      <SharedTabHeader title="Groups" noDivider />
      <Box
        sx={{ minHeight: 300, height: '62vh', width: '95%', mx: 'auto', mt: 1 }}
      >
        <AllGroupsGrid />
      </Box>
    </Box>
  );
}
